import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonClose from 'utils/buttons/ButtonClose';
import ButtonDelete from 'utils/buttons/ButtonDelete';

const ConfirmarBorrado = ({ rol, closeModalDelete, handleDelete }) => {
  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={closeModalDelete}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon="fa-trash-can"
          title="Eliminar"
          size="1x"
          style={{ marginRight: 8, color: '#e63757' }}
        />

        <Modal.Title>Eliminar rol</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          El rol <b>{rol.name}</b> será eliminado y los usuarios que lo tengan
          asignado quedarán sin permisos.
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?
        </div>
        <ModalButtonsContainer>
          <ButtonClose
            text="Cancelar"
            funcion={closeModalDelete}
            variant="secondary"
          />

          <ButtonDelete text="Eliminar" funcion={handleDelete} data={rol.id} />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

ConfirmarBorrado.propTypes = {
  rol: PropTypes.object.isRequired,
  closeModalDelete: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired
};

export default ConfirmarBorrado;
